import script from "./whatsnew.vue?vue&type=script&setup=true&lang=js"
export * from "./whatsnew.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__